<template>
  <div class="d-flex justify-center width-100">
    <hr v-bind:style="styleObj" :class="classes" />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '2px',
    },
    color: {
      type: String,
      default: '#ddd',
    },
    classes: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    styleObj() {
      return {
        width: this.width,
        borderColor: this.color,
        borderWidth: this.height,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables';

hr {
  border-top: 2px solid $gray-text;
  border-right: 0px;
  border-bottom: 0px;
  border-left: 0px;
  height: 0;
}
</style>
